import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['counter', 'label', 'input']

  connect(){
    const delay = 300
    let timer = 0
    this.inputTarget.addEventListener('keyup', () => {
      clearTimeout(timer)
      timer = setTimeout(() => {this.update()}, delay)
    })
    this.update()
  }

  update(){
    const required = parseInt(this.data.get('required'))
    let remaining = 0, text = this.inputTarget.value

    if (text && text.length > 0){
      remaining = required - text.match(/\S+/g).length
    }

    if (remaining > 0) {
      this.counterTarget.innerText = remaining
      this.labelTarget.classList.remove('white')
    } else {
      this.labelTarget.classList.add('white')
    }
  }
}
